require('./bootstrap');

$(window).on('load', function() {
    setTimeout(function() {
        $(window).resize();
    }, 300);
});

$(window).on('resize', function() {
    adjustHeight('.tiles .tile');
});

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]')
        }
    });

    // Menu
    $(document).on('click', '[href="#menu"]', function(e) {
        e.preventDefault();
        $('header nav, header .close').toggleClass('active');
    });

    // Add 'active' class to current page navigation links
    var currentPage = thisURL();
    $('nav a[href$="' + currentPage + '"]').each(function() {
        $(this).addClass('active');
    });

    // Home
    $('#home #page-intro ul').slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1000,
        vertical: true,
        verticalSwiping: true
    });

    // Search
    $(document).on('click', '[href="#search"]', function(e) {
        e.preventDefault();
        $('.overlay, #search').addClass('overlaid');
        setTimeout(function() {
            $('#search-term').focus();
        }, 500);
    });

    $('#search input').on('keyup', function(event) {
        if (event.keyCode == 27) {
            $('.overlaid').removeClass('overlaid');
        }
    });

    // Projects
    $('.tile').on('touchstart touchend', function(e) {
        $(this).toggleClass('active');
    });

    $('.filters li a').on('click', function(e) {
        e.preventDefault();

        var $filters = '';
        $('.filters li a').not(this).removeClass('active');
        $(this).toggleClass('active');

        $('.filters li a.active').each(function() {
            $filters += '.' + $(this).data('filter');
        });

        $tiles.isotope({ filter: $filters });
    });

    $('.tile .categories a').on('click', function(e) {
        e.preventDefault();
        var $cat = $(this).data('category');
        $('.filters a[data-filter="' + $cat + '"]').trigger('click');
    });

    $('.modal-trigger').on('click', function(e) {
        e.preventDefault();

        var $this = $(this);

        if ($('.modal-slider').hasClass('slick-initialized')) {
            $('.modal-slider').slick('unslick');
        }

        $.get($this.data('url'))
        .done(resp => {
            $('.modal-overlay').html(resp);

            if ($('.modal-overlay .modal-slider').length) {
                $('.modal-slider').on('init', function(event, slick) {
                    showModal($this);
                });

                $('.modal-slider').slick({
                    arrows: true,
                    dots: false,
                    variableWidth: true,
                    prevArrow: $('.modal .slide-prev'),
                    nextArrow: $('.modal .slide-next')
                });
            } else {
                showModal($this);
            }
        });
    });

    window.addEventListener('popstate', function() {
        $page = location.pathname.split('/').pop();

        if ($('.overlaid').length > 0) {
            closeModal();
        } else {
            $('.modal-trigger[href$="' + $page + '"]').trigger('click');
        }
    });

    $(document).on('click', '.modal-overlay.overlaid, .modal-overlay.overlaid .close', function(e) {
        if ($(e.target).is('.overlaid') || $(e.target).closest('.close').length) {
            e.stopPropagation();
            closeModal();
            let path = location.pathname.split('/')[location.pathname.split('/').length - 2];
            history.pushState(null, null, '/' + path);
            document.title = path[0].toUpperCase() + path.substring(1) + ' | Appselec';
        }
    });

    function showModal($this) {
        $('.modal-overlay').addClass('overlaid');
        let $page = location.pathname.split('/').pop();

        if ($page !== $this.attr('href').split('/').pop()) {
            history.pushState(null, null, $this.attr('href'));
            document.title = $this.siblings('.title').text() + ' | Appselec';
        }
    }

    function closeModal() {
        $('.modal-overlay.overlaid').removeClass('overlaid');
    }

    // Fix SVG for older browsers
    svg4everybody();

    // Overlay
    $('.overlay .close').on('click', function(e) {
        e.preventDefault();
        $('.overlaid').removeClass('overlaid');
    });

    // Positive message timeout
    setTimeout(function() {
        $('.message.positive').animate({
            height: 'toggle',
            opacity: 'toggle'
        }, 500);
    }, 5000);

    // Accordion
    if ($('.toggle .toggle-title').hasClass('active')) {
        $('.toggle .toggle-title.active').closest('.toggle').find('.toggle-inner').show();
    }
    $('.toggle .toggle-title').click(function() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active').closest('.toggle').find('.toggle-inner').slideUp(200);
        }
        else {
            $(this).addClass('active').closest('.toggle').find('.toggle-inner').slideDown(200);
        }
    });

    // Default Slick Slider
    $('.default-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 4000
    });

    // Convert .svg image to SVG format (add class="svg")
    $('img.svg').each(function() {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }

            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);
        }, 'xml');
    });

    // Videos in Sliders
    var slideWrapper = $('.main-slider'),
        iframes = slideWrapper.find('.embed-player'),
        lazyImages = slideWrapper.find('.slide-image'),
        lazyCounter = 0;

    // DOM Ready
    $(function () {
        // Initialize
        slideWrapper.on('init', function (slick) {
            slick = $(slick.currentTarget);
            setTimeout(function () {
                playPauseVideo(slick, 'play');
            }, 1000);
            resizePlayer(iframes, 16 / 9);
        });
        slideWrapper.on('beforeChange', function (event, slick) {
            slick = $(slick.$slider);
            playPauseVideo(slick, 'pause');
        });
        slideWrapper.on('afterChange', function (event, slick) {
            slick = $(slick.$slider);
            playPauseVideo(slick, 'play');
        });
        slideWrapper.on('lazyLoaded', function (event, slick, image, imageSource) {
            lazyCounter++;
            if (lazyCounter === lazyImages.length) {
            lazyImages.addClass('show');
            // slideWrapper.slick('slickPlay');
            }
        });

        //start the slider
        slideWrapper.slick({
            // fade:true,
            autoplaySpeed: 4000,
            lazyLoad: 'progressive',
            speed: 1000,
            arrows: false,
            dots: true,
            cssEase: 'cubic-bezier(0.87, 0.03, 0.41, 0.9)'
        });
    });

    // Resize event
    $(window).on('resize.slickVideoPlayer', function () {
      resizePlayer(iframes, 16 / 9);
    });

    // Prevent Sticky Hover on touchscreen devices
    var isTouch = false,
        isTouchTimer,
        curRootClass = '';

    function addTouchClass(e) {
        clearTimeout(isTouchTimer);
        isTouch = true;
        if (curRootClass != 'can-touch') {
            curRootClass = 'can-touch';
            $('body').addClass(curRootClass);
        }
        isTouchTimer = setTimeout(function() {
            isTouch = false
        }, 500);
    }

    function removeTouchClass(e) {
        if (! isTouch && curRootClass == 'can-touch') {
            isTouch = false;
            curRootClass = '';
            $('body').removeClass('can-touch');
        }
    }

    $(document).on('touchstart', addTouchClass());
    $(document).on('mouseover', removeTouchClass());
});

function adjustHeight($tar) {
    var $newH = 0;

    $($tar).each(function() {
        if ($(this).outerHeight() > $newH) {
            $newH = $(this).outerHeight();
        }
    }).outerHeight($newH);

    initIsotope();
}

function initIsotope() {
    $tiles = $('.tiles').isotope({
        itemSelector: '.tile',
        layoutMode: 'fitRows'
    });

    $tiles.on('arrangeComplete', function() {
        $('.no-results').toggleClass('active', $('.tiles .tile:visible').length <= 0);
    });

    var hash = window.location.hash.substr(1);
    $('.filters li a[data-filter="' + hash.toLowerCase() + '"]').trigger('click');
}

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command) {
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), '*');
}

// When the slide is changing
function playPauseVideo(slick, control) {
    var currentSlide, slideType, startTime, player, video;

    currentSlide = slick.find('.slick-current');
    slideType = currentSlide.attr('class').split(' ')[1];
    player = currentSlide.find('iframe').get(0);
    startTime = currentSlide.data('video-start');

    if (slideType === 'vimeo') {
        switch (control) {
            case 'play':
                if ((startTime != null && startTime > 0) && !currentSlide.hasClass('started')) {
                    currentSlide.addClass('started');
                    postMessageToPlayer(player, {
                        'method': 'setCurrentTime',
                        'value': startTime
                    });
                }
                postMessageToPlayer(player, {
                    'method': 'play',
                    'value': 1
                });
            break;
            case 'pause':
                postMessageToPlayer(player, {
                    'method': 'pause',
                    'value': 1
                });
            break;
        }
    } else if (slideType === 'youtube') {
        switch (control) {
            case 'play':
                postMessageToPlayer(player, {
                    'event': 'command',
                    'func': 'mute'
                });
                postMessageToPlayer(player, {
                    'event': 'command',
                    'func': 'playVideo'
                });
            break;
            case 'pause':
                postMessageToPlayer(player, {
                    'event': 'command',
                    'func': 'pauseVideo'
                });
            break;
        }
    } else if (slideType === 'video') {
        video = currentSlide.children('video').get(0);
        if (video != null) {
            if (control === 'play') {
                video.play();
            } else {
                video.pause();
            }
        }
    }
}

// Resize player
function resizePlayer(iframes, ratio) {
    if (!iframes[0]) return;
    var win = $('.main-slider'),
        width = win.width(),
        playerWidth,
        height = win.height(),
        playerHeight,
        ratio = ratio || 16 / 9;

    iframes.each(function () {
        var current = $(this);
        if (width / ratio < height) {
            playerWidth = Math.ceil(height * ratio);
            current.width(playerWidth).height(height).css({
                left: (width - playerWidth) / 2,
                top: 0
            });
        } else {
            playerHeight = Math.ceil(width / ratio);
            current.width(width).height(playerHeight).css({
                left: 0,
                top: (height - playerHeight) / 2
            });
        }
    });
}

function thisURL(params) {
    var url,
        thisURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
        thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisURL, '/', 2));
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisURL = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
        thisURL = thisURL.substring(0, (thisURL.indexOf('?') == -1) ? thisURL.length : thisURL.indexOf('?'));
        thisURL = thisURL.substring(0, getPosition(thisURL, '/', 2));
        url = thisURL;
    }

    if (url == '/') {
        url = '/home';
    }

    return url;
}

function thisSubURL(params) {
    var url,
        thisSubURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
        thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisSubURL, '/', 3));
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
        thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('?') == -1) ? thisSubURL.length : thisSubURL.indexOf('?'));
        thisSubURL = thisSubURL.substring(0, getPosition(thisSubURL, '/', 3));
        url = thisSubURL;
    }

    if (url == '/') {
        url = '/home';
    }

    return url;
}

function getPosition(string, subString, index) {
   return string.split(subString, index).join(subString).length;
}
